import { InvoiceByJobFilters as Filters } from './useInvoiceByJobFilters'
import MultiSelect from '../../common/FormControls/MultiSelect'
import VisitReviewStatusFilter from './VisitReviewStatusFilter'

type FieldsProps = { filters: Filters }

const AdditionalFilterFields = ({ filters, showVisitReviewStatus }: FieldsProps & { showVisitReviewStatus?: boolean }) => {
  const { scheduledStatus, projectType, divisions } = filters.state

  return <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
    {showVisitReviewStatus && <div>
      <div style={{ marginBottom: 4 }}>Visit Review Status</div>
      <VisitReviewStatusFilter filters={filters} style={{ width: '100%' }} />
    </div>}
    <div>
      <div style={{ marginBottom: 4 }}>Work Area Status</div>
      <MultiSelect
        options={scheduledStatus.values.map(x => ({ label: x.name, value: x.value }))}
        selectedValues={scheduledStatus.values.filter(x => x.selected).map(x => x.value)}
        onChange={selectedValues => filters.setCategory('scheduledStatus', selectedValues)}
        placeholder="Select statuses"
        allSelectedText="All Statuses"
        maxTagCount={4}
        style={{ width: '100%' }}
      />
    </div>
    <div>
      <div style={{ marginBottom: 4 }}>Job Types</div>
      <MultiSelect
        options={projectType.values.map(x => ({ label: x.name, value: x.value }))}
        selectedValues={projectType.values.filter(x => x.selected).map(x => x.value)}
        onChange={selectedValues => filters.setCategory('projectType', selectedValues)}
        placeholder="Select job types"
        allSelectedText="All Job Types"
        maxTagCount={4}
        style={{ width: '100%' }}
      />
    </div>
    <div>
      <div style={{ marginBottom: 4 }}>Division</div>
      <MultiSelect
        options={divisions.values.map(x => ({ label: x.name, value: x.value }))}
        selectedValues={divisions.values.filter(x => x.selected).map(x => x.value)}
        onChange={selectedValues => filters.setCategory('divisions', selectedValues)}
        placeholder="Select divisions"
        allSelectedText="All Divisions"
        maxTagCount={4}
        style={{ width: '100%' }}
      />
    </div>
  </div>
}


export default AdditionalFilterFields
